import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconlyFilledHomeIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M7.61223 17.3111V14.763C7.61223 14.1125 8.14339 13.5852 8.79861 13.5852H11.1938C11.5084 13.5852 11.8102 13.7093 12.0327 13.9302C12.2551 14.1511 12.3801 14.4506 12.3801 14.763V17.3111C12.3782 17.5815 12.485 17.8416 12.6769 18.0335C12.8688 18.2254 13.13 18.3333 13.4024 18.3333H15.0364C15.7996 18.3353 16.5322 18.0357 17.0726 17.5007C17.6129 16.9656 17.9166 16.2391 17.9166 15.4815V8.22237C17.9166 7.61037 17.6433 7.02986 17.1704 6.63721L11.6116 2.22988C10.6446 1.45712 9.25918 1.48207 8.32108 2.28914L2.8891 6.63721C2.39387 7.01828 2.09788 7.60052 2.08325 8.22237V15.4741C2.08325 17.0532 3.37274 18.3333 4.9634 18.3333H6.56016C7.12594 18.3333 7.58575 17.8802 7.58985 17.3185L7.61223 17.3111Z"
        fill={props.fill || "" || "#224788"}
      />
    </svg>
  );
};

export default IconlyFilledHomeIcon;
